module.exports = __webpack_public_path__ + "static/img/call.7552fd9d.svg";